// extracted by mini-css-extract-plugin
export default {"footer":"footer___bTWt6X3","action":"action___bTWt6X3","btn":"btn___bTWt6X3"};